'use client';

import * as React from 'react';
import { ContentWrapper } from '../ui/content-wrapper';
import { useAppStore } from '@/lib/frontend/store/hooks';
import ProcessingRequestPage from './processing';
import { H1, P } from '@/components/ui/typography';
import { MailToSupport } from './mail-to-support';
import { SignInForm } from './sign-in-form';
import { Divider } from '@/components/ui/divider';
import { SignUpForm } from './sign-up-form';

export const SignInPage = ({
  preventRedirect = false,
  // sessionInitFailed,
  processingFancyLogin,
  processingFancyLoginReason,
}: {
  preventRedirect?: boolean;
  sessionInitFailed?: boolean;
  processingFancyLogin?: boolean;
  processingFancyLoginReason?: string;
}) => {
  const store = useAppStore();
  const [usingFancyLogin, setUsingFancyLogin] = React.useState(false);

  React.useEffect(() => {
    store.dispatch({
      type: 'RESET_SIGN_IN_FORM',
    });

    const searchParams = new URLSearchParams(window.location.search);
    const tempPassword = searchParams.get('temppass');
    const email = searchParams.get('email');
    if (tempPassword != null && email != null) {
      setUsingFancyLogin(true);
    }
  }, []);

  if (processingFancyLogin && processingFancyLoginReason != null) {
    return <ProcessingRequestPage message={processingFancyLoginReason} />;
  }

  return (
    <ContentWrapper className="flex flex-col gap-16 pt-16">
      <div className="flex gap-10 justify-between sm:flex-row flex-col">
        <div className="flex-1 flex flex-col gap-5">
          <H1 className="text-2xl">Sign In to Your Account</H1>
          <SignInForm preventRedirect={preventRedirect} />
        </div>

        {!usingFancyLogin && (
          <div className="flex-1 flex flex-col gap-5">
            <H1 className="text-2xl">New user? Create an account.</H1>
            <SignUpForm />
          </div>
        )}
      </div>

      <div>
        <P className="text-center text-sm opacity-80">
          Please contact us at <MailToSupport /> if you need assistance.
        </P>
      </div>

      <Divider />
    </ContentWrapper>
  );
};
